import { ETH } from '../constants/assets'
import type { ChainConfig } from '../types'
import { getQuickNodeRpcUrl } from '../utils/getQuickNodeRpcUrl'

export const UNICHAIN = {
  name: 'unichain',
  chainId: 130,
  averageBlockTimeSeconds: 1,
  explorerUrl: 'https://uniscan.xyz',
  nativeAsset: ETH,
  slip44: 60,
  wrappedNativeAsset: '0x4200000000000000000000000000000000000006',
  blockscoutApiUrl: 'https://unichain.blockscout.com/api',
  etherscanSupported: true,
  publicRpcUrls: ['https://unichain.drpc.org', 'https://0xrpc.io/uni'],
  getPrivateRpcUrls: () => {
    const unichain: string[] = []
    process.env.ROUTEME_API_KEY && unichain.push(`https://lb.routeme.sh/rpc/130/${process.env.ROUTEME_API_KEY}`)
    const quickNodeUrl = getQuickNodeRpcUrl('unichain')
    quickNodeUrl && unichain.push(quickNodeUrl)
    process.env.INFURA_API_KEY && unichain.push(`https://unichain-mainnet.infura.io/v3/${process.env.INFURA_API_KEY}`)
    process.env.ALCHEMY_API_KEY &&
      unichain.push(`https://unichain-mainnet.g.alchemy.com/v2/${process.env.ALCHEMY_API_KEY}`)
    return unichain
  },
} as const satisfies ChainConfig
